<template>
  <div>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Payments ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Transactions</h1>
        </div>
      </div>

      <div class="row align-items-end my-4">
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Period Range</label>
            <select class="form-control" v-model="periodParams">
              <option value selected disabled>Please Select Period</option>
              <option value="range">Range</option>
              <option value="30-days">30-day</option>
              <option value="7-days">7-day</option>
            </select>
          </div>
        </div>
        <div
          class="col-xl-2 col-lg-6 col-12 px--5"
          v-if="periodParams === 'range'"
        >
          <div class="form-group">
            <label>Start Date</label>
            <input type="date" class="form-control" v-model="start_date" />
          </div>
        </div>
        <div
          class="col-xl-2 col-lg-6 col-12 px--5"
          v-if="periodParams === 'range'"
        >
          <div class="form-group">
            <label>Stop Date</label>
            <input type="date" class="form-control" v-model="stop_date" />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class=" form-group">
            <label for="">Customer Type</label>
            <select
              name="customer_type"
              id=""
              v-model="customer_type"
              class=" form-control"
            >
              <option value="" selected disabled
                >Please Select Customer Type</option
              >
              <option value="terminal">Terminal</option
              ><option value="customer">Customer</option>
            </select>
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Transaction Type</label>
            <select
              name="plan"
              id
              class="form-control"
              v-model="transaction_type"
            >
              <option value="" selected>Select Transaction Type</option>
              <option value="inter-bank">Inter Bank Transfer</option>
              <option value="intra-bank">Intra Bank Transfer</option>
              <option value="airtime">Airtime</option>
              <option value="data">Data</option>
              <option value="power">Power</option>
              <option value="TV">TV</option>
              <option value="cashout">Cashout</option>
            </select>
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Channel</label>
            <select
              name="plan"
              id
              class="form-control"
              v-model="provider"
            >
              <option value="" selected>Select Transaction Type</option>
              <option value="core-banking">Core-Banking</option>
              <option value="easypay">Easypay</option>
              <option value="vtpass">Vtpass</option>
              <option value="resopot">Resopot</option>
            </select>
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Reference</label>
            <input
              type="text"
              class="form-control"
              v-model="searchParams"
              placeholder="Search By Transaction Reference"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Username</label>
            <input
              type="text"
              class="form-control"
              v-model="usernameParams"
              placeholder="Search By Customer's Username"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Account NO</label>
            <input
              type="text"
              class="form-control"
              v-model="account_number"
              placeholder="Search Account NO"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>TerminalID</label>
            <input
              type="text"
              class="form-control"
              v-model="terminalID"
              placeholder="Search By TerminalID"
            />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Status</label>
            <select name="plan" id class="form-control" v-model="status">
              <option value="" selected>Select Status</option>
              <option value="successful">Successful</option>
              <option value="failed">Failed</option>
              <option value="pending">Pending</option>
              <option value="reversed">Reversed</option>
            </select>
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <button @click.prevent="getTransaction(1)" class="button btn">
              <span class="custom-loader" v-if="loading">
                <loader-icon size="1.5x" class="custom-class"></loader-icon>
                <span style="font-weight: 600; text-transform: initial;"
                  >Please Wait</span
                >
              </span>
              <span v-else>Submit</span>
            </button>
          </div>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Transactions</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="payments"
              :fields="fields"
              :items-per-page="small ? 20 : 20"
              pagination
              sorter
              tableFilter
            >
              <template #transaction_reference="{item}">
                <td class="table--action-mobile">
                  {{ item.transaction_reference }}<br />
                  <span class="badge" 
                      :class="{
                        'badge-success': item.terminal_id,
                        'badge-default': item.account_id
                      }"
                      >                        
                       {{ item.terminal  ? 'Terminal' : '' }}
                       {{ item.account_id  ? 'Account' : '' }}
                    </span>
                    <div v-if="item.terminal">
                        {{ item.terminal.name }}<br />
                        {{ item.terminal.terminalID }}
                    </div>
                </td>
              </template>
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #name="{item}">
                <td class="table--action-mobile">
                  {{ item.user.first_name }} {{ item.user.last_name }}
                </td>
              </template>
              <template #action="{item}">
                <td class="table--action-mobile">
                  <router-link
                    :event="permissions.includes('payments') ? 'click' : ''"
                    class="button"
                    :class="
                      permissions.includes('view-payment')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    "
                    :to="{
                      name: 'Payment',
                      params: { slug: item.transaction_reference }
                    }"
                  >
                    View
                  </router-link>
                  <button
                    @click.prevent="showPaymentModal(item)"
                    class="button"
                    :class="
                      permissions.includes('view-payment')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    ">
                    Glance
                  </button>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>
    </div>
    <TransactionGlanceComponent 
       :transaction="currentPayment"
        v-if="paymentModal"
        @close="closePaymentPmodal"
     />
  </div>
</template>

<script>
import CCard from "@/components/CCard";
import TransactionDataTable from "@/components/TransactionDatatable";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import CPagination from "@/components/CPagination.vue";
import CDataTable from "@/components/CDataTable.vue";
import CModal from "../../components/CModal.vue";
import TransactionGlanceComponent from "../../components/TransactionGlanceComponent.vue";
const fields = [
  // "created_at",
  "description",
  "transaction_reference",
  "name",
  "type",
  "status",
  // "method",
  "total_amount",
  "date",
  "action"
];

export default {
  name: "Payments",
  components: {
    CCard,
    CModal,
    TransactionGlanceComponent,
    CDataTable,
    CPagination,
    TransactionDataTable
  },
  data() {
    return {
      activeColor: "#2CB858",
      textColor: "#001833",
      valueColor: "#001833",
      small: 100,
      payments: [],
      next_page: 1,
      current: 1,
      total: 1,
      transactionStats: {},
      startDate: "",
      stopDate: "",
      searchQuery: "",
      planQuery: "",
      loading: false,
      tableLength: 0,
      next_page: 1,
      total: 1,
      current: 1,
      fields,
      pageLoading: true,
      transaction_type: "",
      periodParams: "",
      start_date: "",
      stop_date: "",
      usernameParams: "",
      account_number: "",
      terminalID: "",
      searchParams: "",
      error_status: false,
      status: "",
      customer_type: "",
      provider: "",
      paymentModal: false,
      currentPayment : null
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    async searchFunction() {
      this.$refs.reports.getReports();
    },
    async getTransaction(page) {
      try {
        const response = await ApiService.get(
          `payment/all?page=${page}&username=${this.usernameParams}&payment_type=${this.transaction_type}&period=${this.periodParams}&status=${this.status}&search=${this.searchParams}&start_date=${this.start_date}&stop_date=${this.stop_date}&customer_type=${this.customer_type}&account_number=${this.account_number}&terminalID=${this.terminalID}&provider=${this.provider}`
        );
        this.payments = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.pageLoading = false;
      } catch (error) {
        console.log(error);
        this.pageLoading = false;
        this.error_status = true;
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        console.log(this.next_page);
        if (this.error_status == false) {
          this.getTransaction(this.next_page);
        }
      }
    },
    showPaymentModal(payment) {
      this.currentPayment = payment;
      this.paymentModal = true;
    },
    closePaymentPmodal() {
      this.paymentModal = false;
      this.currentPayment = null;
    }
  },
  mounted() {
    // this.transactions(1);
    //   this.getTransactions()
    // this.getTransactionStats();
    this.getTransaction(1);
  }
};
</script>

<style></style>
